import { OnderwijsLocatie } from '@models/onderwijs-locatie.model';

export interface OnderwijslocatiesStateModel {
  onderwijslocaties: OnderwijsLocatie[] | null;
  selectOnderwijslocatie: OnderwijsLocatie | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const onderwijslocatieInitialState: OnderwijslocatiesStateModel = {
  onderwijslocaties: null,
  selectOnderwijslocatie: null,
  loading: false,
  loaded: false,
  error: null,
};
